import Getintouch from '../components/getintouch.js';
import Smb from '../components/smallbanner';
import Services from '../components/services';
import Loading from '../components/loading';

export default function Ourservices(){
    return (
        <div>
            <Smb />
            <h2 className="p-5">Our Services</h2>
            <Loading />
            <Services />

            <Getintouch />
            
        </div>
    );
}